import React from 'react';
import styled from 'styled-components';

import mainLogo from 'images/favicon.png';

import Background from 'components/Modal/Background';
import { ModalWindow } from 'components/Modal';

const JWTErrorPopup = () => (
  <div>
    <Background />
    <ModalWindow height="60%">
      <LogoContainer>
        <Logo src={mainLogo} alt="Foresight Factory - Ayda" />
      </LogoContainer>
      <P>Unfortunately an error has occured. Please try logging out and back in to FFonline.<br />If this issue persists, please get in contact with your Account Manager or the team at <A href="mailto:ffonline-help@foresightfactory.co">ffonline-help@foresightfactory.co</A>.</P>
    </ModalWindow>
  </div>
);

const LogoContainer = styled.div`
  text-align: center;
  margin-bottom: 40px;
`;

const Logo = styled.img`
  width: 200px;
`;

const P = styled.p`
  text-align: center;
  font-size: 20px;
`;

const A = styled.a`
  padding: 0;
`;

export default JWTErrorPopup;



// WEBPACK FOOTER //
// ./app/components/JWTErrorPopup/index.js